import { render, staticRenderFns } from "./AppendixCashback.vue?vue&type=template&id=63ad47ee&scoped=true"
import script from "./AppendixCashback.vue?vue&type=script&lang=js"
export * from "./AppendixCashback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad47ee",
  null
  
)

export default component.exports